import { render, staticRenderFns } from "./RelatorioProposta.vue?vue&type=template&id=686724ec"
import script from "./RelatorioProposta.vue?vue&type=script&lang=js"
export * from "./RelatorioProposta.vue?vue&type=script&lang=js"
import style0 from "./RelatorioProposta.vue?vue&type=style&index=0&id=686724ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports